import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../loader.css";

const WEBGL_BASE_URL = "https://storageaicondata.blob.core.windows.net/webgl/AIHumans_Login_Build_Final/index.html";

function UserMyCases() {
    const [cases, setCases] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getToken = () => {
        try {
            const raw = localStorage.getItem("state");
            if (raw) return JSON.parse(raw).auth?.token;
        } catch (e) { }
        return null;
    };

    useEffect(() => {
        LoadMyCases();
    }, []);

    const LoadMyCases = () => {
        const token = getToken();
        const headers = { ...(token && { Authorization: `Bearer ${token}` }) };

        // Fire reset first (silent -- don't wait, don't block page load on failure)
        axios.post(`${process.env.REACT_APP_API_URL}/AppUser/ResetDailyQuota`, {}, { headers })
            .catch(() => { }); // swallow -- page must load regardless

        axios
            .get(`${process.env.REACT_APP_API_URL}/AppUser/GetMyCases`, {
                headers,
            })
            .then((res) => {
                setCases(res.data || []);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Failed to load cases", err);
                setIsLoading(false);
            });
    };

    const PlayCase = (item) => {
        if (!item.case_Url && !item.Case_Url) {
            Swal.fire({
                title: "Not available",
                text: "This case doesn't have a build link yet. Please contact support.",
                icon: "warning",
                confirmButtonText: "Ok",
            });
            return;
        }
        const remaining = item.remaining_Characters ?? item.Remaining_Characters ?? 0;
        if (remaining <= 0) {
            Swal.fire({
                title: "Limit reached",
                text: "You've used up today's limit for this case. Please try again after the daily reset.",
                icon: "warning",
                confirmButtonText: "Ok",
            });
            return;
        }
        const caseUrl = item.case_Url || item.Case_Url || "";
        const queryString = caseUrl.includes("?") ? caseUrl.split("?")[1] : "";
        window.open(`${WEBGL_BASE_URL}?${queryString}`, "_blank");
    };

    return (
        <>
            <div className="page-content-wrapper">
                {isLoading ? (
                    <div className="page-content d-flex justify-content-center align-items-center">
                        <div className="my-wrapper">
                            <div className="spinner center">
                                <div className="spinner-blade"></div>
                                <div className="spinner-blade"></div>
                                <div className="spinner-blade"></div>
                                <div className="spinner-blade"></div>
                                <div className="spinner-blade"></div>
                                <div className="spinner-blade"></div>
                                <div className="spinner-blade"></div>
                                <div className="spinner-blade"></div>
                                <div className="spinner-blade"></div>
                                <div className="spinner-blade"></div>
                                <div className="spinner-blade"></div>
                                <div className="spinner-blade"></div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="page-content">
                        <div className="page-bar">
                            <div className="page-title-breadcrumb">
                                <div className="pull-left">
                                    <div className="page-title">My Cases</div>
                                </div>
                                <ol className="breadcrumb page-breadcrumb pull-right">
                                    <li>
                                        <i className="fa fa-home"></i>&nbsp;
                                        <a className="parent-item" href="/index">Home</a>
                                        &nbsp;<i className="fa fa-angle-right"></i>
                                    </li>
                                    <li className="active">My Cases</li>
                                </ol>
                            </div>
                        </div>

                        <div className="state-overview">
                            <div className="row dashboard-card-wrapper">
                                {cases.length === 0 && (
                                    <div className="col-12">
                                        <p>You don't have any cases assigned yet.</p>
                                    </div>
                                )}
                                {cases.map((item) => {
                                    const patientId = item.patient_Id || item.Patient_Id;
                                    const caseName = item.case_Name || item.Case_Name;
                                    const gender = item.gender || item.Gender;
                                    const remaining = item.remaining_Characters ?? item.Remaining_Characters ?? 0;
                                    const max = item.max_Characters || item.Max_Characters;
                                    return (
                                        <div className="col-xl-4 col-md-6 col-12 mb-4" key={patientId}>
                                            <a onClick={() => PlayCase(item)} style={{ cursor: "pointer" }}>
                                                <div className={"info-box h-100 " + (remaining > 0 ? "bg-blue" : "bg-red")}>
                                                    <span className="info-box-icon push-bottom">
                                                        <i className="material-icons">play_circle_filled</i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="progress-description">{caseName}</span>
                                                        <span className="info-box-text genderfont" style={{ fontSize: "13px" }}>
                                                            {gender}
                                                        </span>
                                                        <span className="info-box-number">
                                                            {remaining} / {max} characters left today
                                                        </span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default UserMyCases;